import React from 'react';
import withTheme from 'app/ui/config/withTheme';
import './style/GradientBackground.css';
import ThemedGradient from '../../config/ThemedGradient';

class GradientBackground extends React.Component {
  render() {
    return (
      <ThemedGradient
        color="common.GradientBackground.color"
        gradient="common.GradientBackground.gradient"
        render={style => (
          <div className="GradientBackground" style={style}>
            {this.props.children}
          </div>
        )}
      />
    );
  }
}

export default withTheme(GradientBackground);



// WEBPACK FOOTER //
// ./src/app/ui/core/common/GradientBackground.js